var map = {
	"./icon-character__adolf-hitler-hover.svg": 63,
	"./icon-character__adolf-hitler.svg": 176,
	"./icon-character__albert-camus-hover.svg": 64,
	"./icon-character__albert-camus.svg": 177,
	"./icon-character__angela-merkel-hover.svg": 65,
	"./icon-character__angela-merkel.svg": 178,
	"./icon-character__bertolt-brecht-hover.svg": 66,
	"./icon-character__bertolt-brecht.svg": 179,
	"./icon-character__francisco-franco-hover.svg": 67,
	"./icon-character__francisco-franco.svg": 180,
	"./icon-character__francois-mitterrand-hover.svg": 68,
	"./icon-character__francois-mitterrand.svg": 181,
	"./icon-character__hannah-arendt-hover.svg": 69,
	"./icon-character__hannah-arendt.svg": 182,
	"./icon-character__joan-miro-hover.svg": 70,
	"./icon-character__joan-miro.svg": 183,
	"./icon-character__john-lennon-hover.svg": 71,
	"./icon-character__john-lennon.svg": 184,
	"./icon-character__josef-stalin-hover.svg": 72,
	"./icon-character__josef-stalin.svg": 185,
	"./icon-character__karl-marx-hover.svg": 73,
	"./icon-character__karl-marx.svg": 186,
	"./icon-character__lech-walesa-hover.svg": 74,
	"./icon-character__lech-walesa.svg": 187,
	"./icon-character__margaret-thatcher-hover.svg": 75,
	"./icon-character__margaret-thatcher.svg": 188,
	"./icon-character__marguerite-duras-hover.svg": 76,
	"./icon-character__marguerite-duras.svg": 189,
	"./icon-character__miguel-de-unamuno-hover.svg": 77,
	"./icon-character__miguel-de-unamuno.svg": 190,
	"./icon-character__nicolae-ceausescu-hover.svg": 78,
	"./icon-character__nicolae-ceausescu.svg": 191,
	"./icon-character__silvio-berlusconi-hover.svg": 79,
	"./icon-character__silvio-berlusconi.svg": 192,
	"./icon-character__simone-de-beauvoir-hover.svg": 80,
	"./icon-character__simone-de-beauvoir.svg": 193,
	"./icon-character__stefan-zweig-hover.svg": 81,
	"./icon-character__stefan-zweig.svg": 194,
	"./icon-character__vladimir-putin-hover.svg": 82,
	"./icon-character__vladimir-putin.svg": 195,
	"./icon-event__caida-del-comunismo-hover.svg": 83,
	"./icon-event__caida-del-comunismo.svg": 196,
	"./icon-event__conflicto-en-los-balcanes-hover.svg": 84,
	"./icon-event__conflicto-en-los-balcanes.svg": 197,
	"./icon-event__el-reino-unido-del-brexit-hover.svg": 85,
	"./icon-event__el-reino-unido-del-brexit.svg": 198,
	"./icon-event__el-terrorismo-islamico-hover.svg": 86,
	"./icon-event__el-terrorismo-islamico.svg": 199,
	"./icon-event__eta-hover.svg": 87,
	"./icon-event__eta.svg": 200,
	"./icon-event__europa-en-la-posguerra-hover.svg": 88,
	"./icon-event__europa-en-la-posguerra.svg": 201,
	"./icon-event__fin-de-las-colonias-hover.svg": 89,
	"./icon-event__fin-de-las-colonias.svg": 202,
	"./icon-event__guerra-civil-espanola-hover.svg": 90,
	"./icon-event__guerra-civil-espanola.svg": 203,
	"./icon-event__i-guerra-mundial-hover.svg": 91,
	"./icon-event__i-guerra-mundial.svg": 204,
	"./icon-event__ii-guerra-mundial-hover.svg": 92,
	"./icon-event__ii-guerra-mundial.svg": 205,
	"./icon-event__ira-hover.svg": 93,
	"./icon-event__ira.svg": 206,
	"./icon-event__la-europa-de-entreguerras-hover.svg": 94,
	"./icon-event__la-europa-de-entreguerras.svg": 207,
	"./icon-event__la-gran-recesion-hover.svg": 95,
	"./icon-event__la-gran-recesion.svg": 208,
	"./icon-event__la-guerra-fria-hover.svg": 96,
	"./icon-event__la-guerra-fria.svg": 209,
	"./icon-event__los-grandes-imperios-europeos-hover.svg": 97,
	"./icon-event__los-grandes-imperios-europeos.svg": 210,
	"./icon-event__nuevos-populismos-el-auge-de-la-ultraderecha-hover.svg": 98,
	"./icon-event__nuevos-populismos-el-auge-de-la-ultraderecha.svg": 211,
	"./icon-event__revolucion-del-68-hover.svg": 99,
	"./icon-event__revolucion-del-68.svg": 212,
	"./icon-event__revolucion-industrial-hover.svg": 100,
	"./icon-event__revolucion-industrial.svg": 213,
	"./icon-event__revolucion-rusa-hover.svg": 101,
	"./icon-event__revolucion-rusa.svg": 214,
	"./icon-event__transicion-espanola-hover.svg": 102,
	"./icon-event__transicion-espanola.svg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;